import { createSelector } from "reselect";

const selectAllTemplates = (state) => state.templates;

export const selectIsFetchingTemplates = createSelector(
  [selectAllTemplates],
  (template) => template.isFetchingTemplates
);

export const selectTemplates = createSelector(
  [selectAllTemplates],
  (template) => template.templates
);

export const selectTemplatesOnPage = createSelector(
  [selectAllTemplates],
  (template) => template.templatesOnPage
);

export const selectSearchTemplatesQuery = createSelector(
  [selectAllTemplates],
  (template) => template.searchTemplatesQuery
);

export const selectNumTemplates = createSelector(
  [selectAllTemplates],
  (template) => template.numTemplates
);

export const selectSelectedTemplates = createSelector(
  [selectAllTemplates],
  (template) => template.selectedTemplates
);
